import { FaLinkedin } from "react-icons/fa";
import { FaGithubSquare } from "react-icons/fa";
import { FaInstagramSquare } from "react-icons/fa";
import { FaSquareXTwitter } from "react-icons/fa6";


const data = [
    {id:1,link: 'https://www.linkedin.com/in/venkat-naidu-neelapu/', icon :<FaLinkedin />},
    {id:2, link: 'https://github.com/venkatneelapu', icon :<FaGithubSquare />},
    {id:3, link:'https://www.instagram.com/venkat_neelapu/', icon :<FaInstagramSquare />},
    {id:4, link: 'https://x.com/venkata_Neelapu', icon :<FaSquareXTwitter />}
]
export default data;